// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_row__SWC8U {
    /*--item-width: 240px;*/
    display: flex;
    grid-gap: 24px;
    /*grid-template-columns: repeat(4, 1fr);*/
    width: 100%;
    min-width: 100%;
    --item-min-height: 160px;
}

.styles_row__SWC8U.styles_compact__S8DCF {
    --item-min-height: 80px;
}

.styles_checkboxPlaceholder__xBGLw {
    background: rgba(214, 214, 214, 0.1);
    width: 100%;
    height: var(--item-min-height);
    border: 0.5px solid var(--light-grey);
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]} {
    .styles_row__SWC8U:not(.styles_compact__S8DCF) {
        --item-min-height: 160px;
    }
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .styles_checkboxPlaceholder__xBGLw {
        display: none;
    }

    .styles_placeholder__04woV {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/SelectionPopup/SelectionCheckboxRow/styles.module.css"],"names":[],"mappings":"AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,cAAc;IACd,yCAAyC;IACzC,WAAW;IACX,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,WAAW;IACX,8BAA8B;IAC9B,qCAAqC;AACzC;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":["@value screen-lg-min, screen-md-max from '../../../breakpoints.css';\n\n.row {\n    /*--item-width: 240px;*/\n    display: flex;\n    grid-gap: 24px;\n    /*grid-template-columns: repeat(4, 1fr);*/\n    width: 100%;\n    min-width: 100%;\n    --item-min-height: 160px;\n}\n\n.row.compact {\n    --item-min-height: 80px;\n}\n\n.checkboxPlaceholder {\n    background: rgba(214, 214, 214, 0.1);\n    width: 100%;\n    height: var(--item-min-height);\n    border: 0.5px solid var(--light-grey);\n}\n\n@media screen-lg-min {\n    .row:not(.compact) {\n        --item-min-height: 160px;\n    }\n}\n\n@media screen-md-max {\n    .checkboxPlaceholder {\n        display: none;\n    }\n\n    .placeholder {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-lg-min": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]}`,
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"row": `styles_row__SWC8U`,
	"compact": `styles_compact__S8DCF`,
	"checkboxPlaceholder": `styles_checkboxPlaceholder__xBGLw`,
	"placeholder": `styles_placeholder__04woV`
};
export default ___CSS_LOADER_EXPORT___;
